const drawerWidth = 350

export default (theme) => ({
	root: {
		display: 'flex',
	},
	appBar: {
		width: `calc(100% - ${drawerWidth}px)`,
		marginRight: drawerWidth,
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		overflowX: 'hidden',
	},
	toolbar: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.default,
		padding: theme.spacing.unit * 3,
	},
	heading: {
		fontSize: '90%',
		fontWeight: 'bold',
		marginRight: 7,
	},
	color: { color: '#fff' },
	error: { color: theme.palette.red },
	headingIcon: {
		fontSize: '1rem',
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	icon: {
		fontSize: '1rem',
	},
	// expanded: {
	//   margin: 0,
	// },
	expansionPanelSummary: { backgroundColor: theme.palette.secondary.main },
	expansionPanelSummaryDisabled: { backgroundColor: theme.palette.grey[300] },
	expansionPanelSummaryExpanded: {
		borderTopLeftRadius: 35,
		borderTopRightRadius: 35,
	},
	expansionPanelExpanded: {
		borderRadius: '35px !important',
	},
	collapseEntered: {
		overflowY: 'auto',
	},
	menu: {
		width: 200,
	},
	expandIcon: { color: '#fff' },
	leftIcon: {
		marginRight: theme.spacing.unit,
	},
	main: {
		// width: 'calc(100% - 326px)',
	},
	fieldSwitchLabel: {
		maxWidth: '140px',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
	},
	linkButton: {
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
		textDecoration: 'underline',
		display: 'inline',
		margin: 0,
		padding: 0,
		color: '#0000EE',
	},
	fab: {
		// position: 'fixed',
		pointerEvents: 'all',
		color: '#fff',
		zIndex: 4,
		marginBottom: 23,
		marginRight: 70,
		[theme.breakpoints.down('sm')]: {
			bottom: 150,
			right: 23,
			position: 'fixed',
			marginBottom: 0,
			marginRight: 0,
		},
		// [theme.breakpoints.up('md')]: {
		//   bottom: 23,
		//   right: `calc(23px + ${drawerWidth}px)`,
		// },
	},
	snackbarSuccess: { backgroundColor: theme.palette.secondary.main },
	snackbarError: { backgroundColor: theme.palette.red },
	notchedOutline: {
		borderRadius: 28,
		paddingLeft: '40px !important',
	},
	preview: {
		margin: 'auto',
		border: 'solid #dddddd',
		borderRadius: '8px',
		overflowY: 'auto',
	},
	previewCustom: {
		margin: 'auto',
		// overflowY: 'auto',
	},
	desktop: {
		borderWidth: 35,
		width: '90%',
		paddingTop: 35,
		paddingBottom: 35,
		[theme.breakpoints.up('xs')]: {
			height: 600,
			zoom: '0.45',
		},
		[theme.breakpoints.up('sm')]: {
			height: 715,
			zoom: '0.55',
		},
		[theme.breakpoints.up('md')]: {
			height: 840,
			zoom: '0.55',
		},
		[theme.breakpoints.up('lg')]: {
			height: 600,
			zoom: '0.8',
		},
		[theme.breakpoints.up('xl')]: {
			height: 650,
			zoom: '0.8',
		},
	},
	tablet: {
		borderWidth: 24,
		paddingTop: 24,
		paddingBottom: 24,
		[theme.breakpoints.up('xs')]: {
			height: '175vw',
			zoom: '0.55',
			width: '80%',
		},
		[theme.breakpoints.up('sm')]: {
			height: '105vw',
			zoom: '0.65',
			width: '70%',
		},
		[theme.breakpoints.up('md')]: {
			height: '80vw',
			zoom: '0.7',
			width: '75%',
		},
		[theme.breakpoints.up('lg')]: {
			height: '60vw',
			zoom: '0.8',
			width: '75%',
		},
		[theme.breakpoints.up('xl')]: {
			height: '50vw',
			zoom: '0.9',
			width: '70%',
		},
	},
	phone: {
		borderWidth: '15px 3px',
		paddingTop: 15,
		paddingBottom: 15,
		[theme.breakpoints.up('xs')]: {
			height: '205vw',
			zoom: '0.55',
			width: '60%',
		},
		[theme.breakpoints.up('sm')]: {
			height: 1180,
			zoom: '0.55',
			width: 620,
		},
	},
	grid: {
		[theme.breakpoints.down('sm')]: {
			maxWidth: '100%',
			margin: '0',
		},
	},
	listItemIconRoot: {
		verticalAlign: 'middle',
		marginRight: 9,
	},
	responseList: {
		width: '100%',
		maxHeight: 'calc(100vh - 436px)',
		overflowY: 'auto',
		borderRadius: 16,
		border: '1px solid gray',
		[theme.breakpoints.down('sm')]: {
			maxHeight: 'calc(100vh - 305px)',
		},
		[theme.breakpoints.down('xs')]: {
			maxHeight: 'calc(100vh - 281px)',
			// maxWidth: 'calc(100vw - 40px)',
		},
	},
	panel: {
		backgroundColor: '#fff',
		padding: 0,
		height: 64,
		borderBottom: '1px solid #e0e0e0',
		borderRight: '1px solid #e0e0e0',
	},
	container: {
		listStyle: 'none',
	},
	panelContent: {
		padding: '0 20px',
	},
	text: {
		display: 'table-cell',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	textWrapper: {
		fontSize: theme.typography.pxToRem(15),
		display: 'table',
		tableLayout: 'fixed',
		width: '100%',
		whiteSpace: 'nowrap',
		marginBottom: 5,
	},
	questionsAndAnswers: {
		backgroundColor: '#fff',
		borderBottomLeftRadius: 24,
		borderBottomRightRadius: 24,
		overflowX: 'hidden',
		overflowY: 'auto',
		padding: '20px 0 0',
		minHeight: 150,
		maxHeight: 'calc(100vh - 278px)',
		borderBottom: '1px solid gray',
		borderLeft: '1px solid gray',
		borderRight: '1px solid gray',
		[theme.breakpoints.down('sm')]: {
			maxHeight: 'calc(100vh - 267px)',
		},
		[theme.breakpoints.down('xs')]: {
			maxHeight: 'calc(100vh - 259px)',
		},
	},
})
